"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderTabSet = void 0;

var React = require("react");

var DockLocation_1 = require("../DockLocation");

var BorderButton_1 = require("./BorderButton");

var PopupMenu_1 = require("../PopupMenu");

var Actions_1 = require("../model/Actions");

var TabSet_1 = require("./TabSet");

var MAX_TABS = 999;
/** @hidden @internal */

var BorderTabSet =
/** @class */
function (_super) {
  __extends(BorderTabSet, _super);

  function BorderTabSet(props) {
    var _this = _super.call(this, props) || this;

    _this.onInterceptMouseDown = function (event) {
      event.stopPropagation();
    };

    _this.onOverflowClick = function (hiddenTabs) {
      var element = _this.overflowbuttonRef.current;
      PopupMenu_1.default.show(element, hiddenTabs, _this.onOverflowItemSelect, _this.props.layout.getClassName);
    };

    _this.onOverflowItemSelect = function (item) {
      _this.props.layout.doAction(Actions_1.default.selectTab(item.node.getId()));
    };

    _this.hideTabsAfter = MAX_TABS;
    _this.showOverflow = false;
    _this.showToolbar = true;
    _this.renderAllTabs = true;
    _this.toolbarRef = React.createRef();
    _this.overflowbuttonRef = React.createRef();
    return _this;
  }

  BorderTabSet.prototype.componentDidMount = function () {
    this.updateVisibleTabs();
  };

  BorderTabSet.prototype.shouldComponentUpdate = function () {
    this.renderAllTabs = true; // since not the force update of a second render to adjust tabs

    return true;
  };

  BorderTabSet.prototype.componentDidUpdate = function () {
    this.updateVisibleTabs();
  };

  BorderTabSet.prototype.updateVisibleTabs = function () {
    var _this = this;

    if (this.renderAllTabs) {
      var node_1 = this.props.border;

      if (node_1.getChildren().length > 0) {
        var lastChild = node_1.getChildren()[node_1.getChildren().length - 1];

        var isTabVisible = function isTabVisible(i, child, childEnd, borderEnd, toolbarSize) {
          if (childEnd > borderEnd - (20 + toolbarSize)) {
            _this.hideTabsAfter = Math.max(0, i - 1);
            _this.showOverflow = node_1.getChildren().length > 1;

            if (i === 0) {
              _this.showToolbar = false;

              if (childEnd > borderEnd - 20) {
                _this.showOverflow = false;
              }
            }

            _this.renderAllTabs = false;

            _this.forceUpdate(); // re-render to hide some tabs


            return false;
          }

          return true;
        };

        if (node_1.getLocation() === DockLocation_1.default.TOP || node_1.getLocation() === DockLocation_1.default.BOTTOM) {
          var toolbarSize = this.toolbarRef.current.getBoundingClientRect().width;
          var borderEnd = node_1.getTabHeaderRect().getRight();

          if (lastChild.getTabRect().getRight() > borderEnd - toolbarSize) {
            var modifiedChildren = TabSet_1.TabSet.getModifiedNodeList(node_1.getChildren(), node_1.getSelected());

            for (var i = 0; i < modifiedChildren.length; i++) {
              var childTabNode = modifiedChildren[i];
              var childEnd = childTabNode.getTabRect().getRight();

              if (!isTabVisible(i, childTabNode, childEnd, borderEnd, toolbarSize)) {
                return;
              }
            }
          }
        } else {
          var toolbarSize = this.toolbarRef.current.getBoundingClientRect().height;
          var borderEnd = node_1.getTabHeaderRect().getBottom();

          if (lastChild.getTabRect().getBottom() > borderEnd - toolbarSize) {
            var modifiedChildren = TabSet_1.TabSet.getModifiedNodeList(node_1.getChildren(), node_1.getSelected());

            for (var i = 0; i < modifiedChildren.length; i++) {
              var childTabNode = modifiedChildren[i];
              var childEnd = childTabNode.getTabRect().getBottom();

              if (!isTabVisible(i, childTabNode, childEnd, borderEnd, toolbarSize)) {
                return;
              }
            }
          }
        }
      }
    } else {
      this.renderAllTabs = true;
    }
  };

  BorderTabSet.prototype.render = function () {
    var _this = this;

    if (this.renderAllTabs) {
      this.hideTabsAfter = MAX_TABS;
      this.showOverflow = false;
      this.showToolbar = true;
    }

    var cm = this.props.layout.getClassName;
    var border = this.props.border;
    var style = border.getTabHeaderRect().styleWithPosition({});
    var tabs = [];
    var hiddenTabs = [];

    var layoutTab = function layoutTab(i) {
      var isSelected = border.getSelected() === i;
      var showTab = _this.hideTabsAfter >= i;
      var child = border.getChildren()[i];

      if (_this.hideTabsAfter === i && border.getSelected() > _this.hideTabsAfter) {
        hiddenTabs.push({
          name: child.getName(),
          node: child,
          index: i
        });
        child = border.getChildren()[border.getSelected()];
        isSelected = true;
      } else if (!showTab && !isSelected) {
        hiddenTabs.push({
          name: child.getName(),
          node: child,
          index: i
        });
      }

      if (showTab) {
        tabs.push(React.createElement(BorderButton_1.BorderButton, {
          layout: _this.props.layout,
          border: border.getLocation().getName(),
          node: child,
          key: child.getId(),
          selected: isSelected,
          iconFactory: _this.props.iconFactory,
          titleFactory: _this.props.titleFactory,
          closeIcon: _this.props.closeIcon
        }));
      }
    };

    if (border.getLocation() !== DockLocation_1.default.LEFT) {
      for (var i = 0; i < border.getChildren().length; i++) {
        layoutTab(i);
      }
    } else {
      for (var i = border.getChildren().length - 1; i >= 0; i--) {
        layoutTab(i);
      }
    }

    var borderClasses = cm("flexlayout__border_" + border.getLocation().getName());

    if (this.props.border.getClassName() !== undefined) {
      borderClasses += " " + this.props.border.getClassName();
    } // allow customization of tabset right/bottom buttons


    var buttons = [];
    var renderState = {
      headerContent: {},
      buttons: buttons
    };
    this.props.layout.customizeTabSet(border, renderState);
    buttons = renderState.buttons;
    var toolbar;

    if (this.showToolbar === true) {
      toolbar = React.createElement("div", {
        key: "toolbar",
        ref: this.toolbarRef,
        className: cm("flexlayout__border_toolbar_" + border.getLocation().getName())
      }, buttons);
    }

    if (this.showOverflow === true && hiddenTabs.length > 0) {
      var overflowButton = React.createElement("button", {
        key: "overflowbutton",
        ref: this.overflowbuttonRef,
        className: cm("flexlayout__border_button_overflow_" + border.getLocation().getName()),
        onTouchStart: this.onInterceptMouseDown,
        onClick: this.onOverflowClick.bind(this, hiddenTabs),
        onMouseDown: this.onInterceptMouseDown
      }, hiddenTabs.length);
      tabs.push(overflowButton);
    }

    return React.createElement("div", {
      style: style,
      className: borderClasses
    }, React.createElement("div", {
      className: cm("flexlayout__border_inner_" + border.getLocation().getName())
    }, tabs), toolbar);
  };

  return BorderTabSet;
}(React.Component);

exports.BorderTabSet = BorderTabSet;